import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

interface Props {
  severity: any;
}

/* Change the header color of warning messages. */
const getColorBySeverity = (theme: Theme, severity: any) => {
  switch (severity) {
    case "error":
      return theme.palette.error.dark;
      break;
    case "warning":
      return theme.palette.warning.dark;
      break;
    case "info":
      return theme.palette.info.dark;
      break;
    case "success":
      return theme.palette.success.dark;
      break;
    default:
      break;
  }
};

const useStyles = makeStyles<any, Props>((theme: Theme) =>
  createStyles({
    alertHeader: {
      color: "white",
      height: "45px",
      paddingTop: "5px",
      backgroundColor: ({ severity }) => getColorBySeverity(theme, severity),
    },
    alertDescription: {
      paddingTop: "15px",
    },
  }),
);

export interface DialogCommonProps {
  open: boolean;
  confirmAction?: any;
  title: string;
  desc: string;
  disableBackdropClick: boolean;
  confirmLabel: string;
  severity: "warning" | "info" | "error" | "success";
  color?: "primary" | "secondary";
}

/* Show the warning, success, error, and information notification using modal. */
const AlertDialog: React.FunctionComponent<DialogCommonProps> = ({
  open,
  confirmAction,
  title,
  desc,
  confirmLabel,
  severity,
  disableBackdropClick,
  color = "primary",
}) => {
  const classes = useStyles({ severity });

  return (
    <Dialog
      disableBackdropClick={disableBackdropClick}
      className={classes.root}
      open={open}
    >
      <DialogTitle className={classes.alertHeader} id="alert-dialog-title-id">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          className={classes.alertDescription}
          id="alert-dialog-description-id"
        >
          {desc}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={confirmAction}  color={color}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
